// ════════════════════════════════════════
// app/courses/cyber.tsx
// ════════════════════════════════════════
import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';
export default function CyberPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס סייבר ואבטחת מידע',
        metaTitle: 'קורס סייבר ואבטחת מידע 2025 – איך לבחור נכון | Kursi',
        slug: 'cyber',
        metaDescription: 'קורסי סייבר ואבטחת מידע 2025 – Ethical Hacking, SOC, Cloud Security, Bug Bounty. מדריך לבחירת קורס סייבר עם הסמכות מוכרות. קבלו 3 המלצות אישיות.',
        subtitle: 'סייבר הוא אחד התחומים המבוקשים ביותר בהייטק. כאן תבינו מה ללמוד, איך להיכנס לתחום, ומה לבדוק לפני שמשלמים.',
        chips: ['Ethical Hacking', 'SOC', 'Cloud Security', 'Bug Bounty', 'מתחילים', 'מתקדמים'],
        chatSeed: 'קורס סייבר ואבטחת מידע',
        sections: [
          {
            id: 'goal',
            title: 'קודם תחליטו לאיזה תפקיד אתם מכוונים',
            body: 'סייבר זה לא תחום אחד. SOC Analyst, Penetration Tester, Cloud Security, Malware Analyst — כל תפקיד דורש ידע שונה. קורס טוב ישאל אתכם את זה לפני שתירשמו.',
            bullets: [
              'SOC Analyst: ניטור, זיהוי ותגובה לאירועים',
              'Penetration Tester: בדיקות חדירה ופגיעויות',
              'Cloud Security: אבטחת AWS/Azure/GCP',
              'Malware Analyst: ניתוח קוד זדוני',
              'Bug Bounty: מציאת חולשות בתמורה לתגמול',
            ],
          },
          {
            id: 'practice',
            title: 'למה תרגול מעשי הוא חובה בסייבר',
            body: 'סייבר זה תחום שלא לומדים ממצגות. LAB עם מכונות וירטואליות, CTF (Capture The Flag), ופרויקטים אמיתיים — אלה מה שמבדיל בין בוגר שמקבל עבודה לבין מי שלא.',
            bullets: [
              'LAB מעשי עם סביבות וירטואליות',
              'תרגילי CTF (Capture The Flag)',
              'פרויקט גמר עם דוח פנטסטינג אמיתי',
              'הכנה להסמכות: Security+, CEH, OSCP',
            ],
          },
          {
            id: 'certs',
            title: 'הסמכות שכדאי לדעת עליהן',
            body: 'מעסיקים בסייבר מסתכלים על הסמכות. קורס טוב יכין אתכם לבחינות ההסמכה הרלוונטיות ולא רק ילמד תיאוריה.',
            bullets: [
              'CompTIA Security+ — הסמכת כניסה מוכרת',
              'CEH (Certified Ethical Hacker) — פנטסטינג',
              'OSCP — הכי מוכרת ומכובדת בתעשייה',
              'CISSP — לתפקידים בכירים',
            ],
          },
        ],
        checklist: [
          'יש LAB מעשי עם מכונות וירטואליות',
          'הקורס מכין להסמכה מוכרת',
          'המרצה עם ניסיון תעשייתי אמיתי',
          'יש תמיכה ומענה בין השיעורים',
          'יש פרויקט גמר / דוח פנטסטינג',
        ],
        redFlags: [
          'קורס ללא LAB — תיאוריה בלבד',
          'אין הסמכה מוכרת בסוף',
          'הבטחות "תיכנס לסייבר תוך 3 חודשים" ללא רקע',
          'חומר לא מעודכן לאיומים של 2024–2025',
        ],
        faq: [
          { q: 'האם צריך רקע בתכנות לסייבר?', a: 'לא חובה להתחיל, אבל Python בסיסי ו-Linux יקצרו משמעותית את הלמידה. קורסים טובים מספקים בסיס כזה בתחילה.' },
          { q: 'כמה זמן לוקח להיכנס לתחום הסייבר?', a: 'עם קורס רציני ותרגול עצמאי — 6–12 חודשים לתפקיד ראשון כ-SOC Analyst. פנטסטינג דורש שנה–שנתיים.' },
          { q: 'מה ההסמכה הכי שווה להשיג?', a: 'OSCP היא המוכרת ביותר בתעשייה לפנטסטינג. Security+ היא הטובה ביותר לכניסה לתחום.' },
        ],
      }}
    />
  );
}